import { FC, useMemo } from 'react';
import { ServiceRequestDto } from '@/services/api/contracts/serviceRequests';

export const ServiceRequestPayloadViewer: FC<{ request: ServiceRequestDto }> = ({ request }) => {
  const payload = useMemo(() => {
    try {
      return typeof request.payload === 'string' ? JSON.parse(request.payload) : request.payload;
    } catch {
      return request.payload;
    }
  }, [request.payload]);

  return (
    <div className="w-full h-full p-6 bg-white overflow-hidden flex flex-col">
      <h2 className="text-2xl font-bold mb-4 shrink-0">Service Request Payload: {request.requestType}</h2>
      <div className="flex-1 overflow-y-auto">
        <pre className="bg-gray-900 text-green-400 p-4 rounded-md overflow-x-auto text-sm font-mono min-h-full">
          <code>{JSON.stringify(payload, null, 2)}</code>
        </pre>
      </div>
    </div>
  );
};
